import './App.less';
import React from 'react';
import {BrowserRouter, Link, Route, Routes} from 'react-router-dom'
import Header from './Header'
import Home from './Pages/Home'
import Dilemma from './Pages/Dilemma'
import Fiction from './Pages/Fiction'
import Thesis from './Pages/Thesis'
import Review from './Pages/Review'
import Request from './Pages/Request'
import TermsAndConditions from './Pages/TermsAndConditions';
import Blurb from './Pages/Blurb';
import About from './Pages/About';
import Contact from './Pages/Contact';
import Privacy from './Pages/Privacy';
import Audiobooks from './Pages/Audiobook';
import Narration from './Pages/Narration';
import {Layout} from 'antd'
import { FacebookOutlined, TwitterOutlined } from '@ant-design/icons';

const {Content, Footer} = Layout;

function App() {
    return (
        <BrowserRouter>
            <Layout className="layout">
                <Header />
                <Content style={{backgroundColor: 'white'}}>
                    <Layout style={{backgroundColor: 'white'}}>
                        <Routes>
                            <Route path='/proofreading-works-of-fiction' element={<Fiction />} />
                            <Route path='/proofreading-thesis-dissertation-essay' element={<Thesis />} />
                            <Route path='/proof-listen-audiobooks' element={<Audiobooks />} />
                            <Route path='/audiobook-narration-for-picture-books' element={<Narration />} />
                            <Route path='/writers-dilemma' element={<Dilemma />} />
                            <Route path='/writing-your-blurb' element={<Blurb />} />
                            <Route path='/write-back-cover-review' element={<Review />} />
                            <Route path='/request/:type' element={<Request />} />
                            <Route path='/request' element={<Request />} />
                            <Route path='/terms-and-conditions' element={<TermsAndConditions />} />
                            <Route path='/about' element={<About />} />
                            <Route path='/contact' element={<Contact />} />
                            <Route path='/privacy' element={<Privacy />} />
                            <Route exact path='/' element={<Home />} />
                        </Routes>
                    </Layout>
                </Content>
            </Layout>
            <Footer style={{textAlign: 'center'}}>
                &copy;2022 by Vabis' Literature Services,
                read our <Link to='/privacy'>privacy policy</Link>,&nbsp;
                follow us: <Link to='//www.facebook.com/Vabis-Literature-Services-111368391459992/' target='_blank'><FacebookOutlined style={{fontSize: '20px'}} /></Link>&nbsp;
                <Link to='//www.twitter.com/vabisliterature' target='_blank'><TwitterOutlined style={{fontSize: '20px'}} /></Link>
            </Footer>
        </BrowserRouter>
    );
}

export default App;
